import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { createCheggInstance } from '@chegg/optimizely-sdk';
import bowser from 'bowser';
import { OptimizelyAttributes } from './constants';
import { getRegion } from '../GeolocationUtils';
export { default as getShouldExcludeOptimizelyWeb } from './getShouldExcludeOptimizelyWeb';
var optimizelyClient = null;
var cheggOptimizelyConfigurationPromise = null;

/**
 * Take in any parameters needed to initialize optimizely.
 * @param optimizelyConfigParams
 * @returns A config that can be used to initialize optimizely
 */
export function getOptimizelyConfig(optimizelyConfigParams) {
  var rioConfig = optimizelyConfigParams.rioConfig,
    cookieDomain = optimizelyConfigParams.cookieDomain,
    datafile = optimizelyConfigParams.datafile,
    attributes = optimizelyConfigParams.attributes,
    userId = optimizelyConfigParams.userId;
  var optimizelyConfigs = {
    rioConfig: rioConfig,
    cookieDomain: cookieDomain,
    userId: userId,
    attributes: _objectSpread({}, attributes),
    queryStringOnPageLoad: typeof window !== 'undefined' && 'location' in window ? window.location.search : '',
    datafile: datafile
  };
  return optimizelyConfigs;
}

/**
 * Creates a new optimizely client with the required GCE properties attributes.
 * If not all required attributes are known at run-time,
 * leverage the attributes in getOptimizelyVariation and getOptimizelyFeature functions to add more.
 * @param configs
 * @returns
 */
export var getCommerceOptimizelyClient = function getCommerceOptimizelyClient(configs) {
  if (!optimizelyClient) {
    var _parser$browser, _parser, _parser$os, _parser2, _parser$platform, _parser3, _platform$type, _browser$name;
    var userId = configs.userId,
      attributes = configs.attributes;
    // eslint-disable-next-line camelcase
    var FUNNEL_deployEnv = attributes.FUNNEL_deployEnv,
      FUNNEL_country = attributes.FUNNEL_country;
    var parser = null;
    if (typeof window !== 'undefined') {
      parser = bowser.parse(window.navigator.userAgent);
    }
    var browser = (_parser$browser = (_parser = parser) === null || _parser === void 0 ? void 0 : _parser.browser) !== null && _parser$browser !== void 0 ? _parser$browser : {};
    var os = (_parser$os = (_parser2 = parser) === null || _parser2 === void 0 ? void 0 : _parser2.os) !== null && _parser$os !== void 0 ? _parser$os : {};
    var platform = (_parser$platform = (_parser3 = parser) === null || _parser3 === void 0 ? void 0 : _parser3.platform) !== null && _parser$platform !== void 0 ? _parser$platform : {};

    //Internally, this configuration promise waits on Optimizely.onReady, however
    //it seems that when we wait onReady our code gets executed first which breaks
    //forced-allocations. See the promise structure in isFeatureEnabled and getOptimizelyVariation
    var _createCheggInstance = createCheggInstance(_objectSpread(_objectSpread({}, configs), {}, {
        bucketingId: userId
      })),
      optimizely = _createCheggInstance.optimizely,
      configurationPromise = _createCheggInstance.configurationPromise;
    optimizely.setUser({
      id: userId,
      attributes: _objectSpread(_objectSpread({
        chegg_uuid: userId
      }, attributes), {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, OptimizelyAttributes.IS_MOBILE, String(((_platform$type = platform.type) === null || _platform$type === void 0 ? void 0 : _platform$type.toLowerCase()) === 'mobile')), OptimizelyAttributes.BROWSER, (_browser$name = browser.name) !== null && _browser$name !== void 0 ? _browser$name : ''), OptimizelyAttributes.BROWSER_VERSION, browser.name && browser.version ? "".concat(browser.name, " ").concat(browser.version) : ''), OptimizelyAttributes.OS, os.name && os.version ? "".concat(os.name, " ").concat(os.version) : ''), OptimizelyAttributes.REGION, getRegion(FUNNEL_country)), OptimizelyAttributes.DEPLOY_ENV, FUNNEL_deployEnv))
    });
    optimizelyClient = optimizely;
    cheggOptimizelyConfigurationPromise = configurationPromise;
  }
  return {
    optimizelyClient: optimizelyClient,
    cheggOptimizelyConfigurationPromise: cheggOptimizelyConfigurationPromise
  };
};

/**
 * gets the optimizely client and configuration promise
 * @returns {optimizelyClient, cheggOptimizelyConfigurationPromise}
 */
export var getOptimizelySingleton = function getOptimizelySingleton() {
  if (!optimizelyClient || !cheggOptimizelyConfigurationPromise) throw Error('Tried to use optimizely before initialization.');
  return {
    optimizelyClient: optimizelyClient,
    cheggOptimizelyConfigurationPromise: cheggOptimizelyConfigurationPromise
  };
};

/**
 * Determines if a given optimizely experiment is currently running. Note that optimizely should have this functionality
 * natively, but this is just an extra check on our side to be safe.
 * @param isOptimizelyEnabled either a boolean or string value coming from process.env
 * @param experimentName
 * @param experiments datafile with experiments
 * @returns
 */
export var isExperimentRunning = function isExperimentRunning(experimentName, experiments) {
  if (!experiments) return false;
  var _iterator = _createForOfIteratorHelper(experiments),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var experiment = _step.value;
      if (experiment.key === experimentName) return true;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return false;
};

/**
 * parses the isOptimizelyEnabled value from process.env
 * @param isOptimizelyEnabled
 * @returns {boolean} - true if isOptimizelyEnabled is true, 'true', or '1'
 */
export var parseIsOptimizelyEnabled = function parseIsOptimizelyEnabled(isOptimizelyEnabled) {
  return typeof isOptimizelyEnabled === 'boolean' && isOptimizelyEnabled || typeof isOptimizelyEnabled === 'string' && (isOptimizelyEnabled === 'true' || isOptimizelyEnabled === '1');
};

/**
 * deletes the optimizely client and configuration promise
 * @returns {void}
 */
export var deleteOptimizelySingleton = function deleteOptimizelySingleton() {
  optimizelyClient = null;
  cheggOptimizelyConfigurationPromise = null;
};

/**
 * This client-side function activates the experiment based on the experimentKey,
 * allocates the user to a variation, and retuns back that variation.  When experiment or
 * feature are not enabled, this function will return 'BASE'.
 *
 * @param optimizely Optimizely client
 * @param experimentKey OFS experiment key
 * @param featureKey OFS feature key
 * @param uuid
 * @returns OFS user variation
 */
export var getVariation = function getVariation(_ref) {
  var optimizely = _ref.optimizely,
    experimentKey = _ref.experimentKey,
    featureKey = _ref.featureKey,
    uuid = _ref.uuid,
    baseVariation = _ref.baseVariation;
  baseVariation = baseVariation || 'BASE';
  if (optimizely) {
    if (optimizely.isFeatureEnabled(featureKey)) {
      optimizely.activate(experimentKey, uuid);
      return optimizely.getFeatureVariableString(featureKey, 'variation') || baseVariation;
    }
  }
  return baseVariation;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/OptimizelyUtils/index.js
// module id = 3414
// module chunks = 11